export type ApiType = NonNullable<ApiEndpoints['apiType']>;

export const getApiEndpoint = (endpoints: ApiEndpoints[] | undefined, apiType: ApiType): string | undefined =>
	endpoints?.find((e) => e.apiType === apiType)?.url;
